import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Row, Col } from 'react-flexbox-grid'
import { Collapse } from 'react-bootstrap'

import LastVisitedLeagueComponent from './last_visited_league_component'
import RegistrationLeagueComponent from './registration_league_component'
import LeagueNameFilter from './filters/league_name_filter'
import SeasonFilter from './filters/season_filter'
import CategoryFilter from './filters/category_filter'
import TourFilter from './filters/tour_filter'
import SortingFilter from './filters/sorting_filter'
import RegistrationFilter from './filters/registration_filter'
import ViewTypeFilter from './filters/view_type_filter'
import AdvancedFiltersToggle from './filters/advanced_filters_toggle'

class CategoriesFiltersComponent extends Component {
  render() {
    const {
      seasonsOptions, showSeasons, categoriesOptions, showCategoryFilter, toursOptions, showTours,
      leagueName, viewType, advancedFiltersOn, sortingColumn, sortingOrder,
      selectedSeason, selectedCategory, selectedTour, selectedRegistration,
      lastVisitedLeagueData, registrationLeagueData, userIsCustomerManager, userIsTourManager,
      showRegistrationOptions,
      changeFilter, changeSortingColumn, changeSortingOrder,
      dataIsLoading,
      loadingFilters, golfHubEnabled,
    } = this.props
    const userIsManager = userIsCustomerManager || userIsTourManager
    return (
      <div className="categories-filters">
        <Row>
          <Col xs={12} md={12} lg={4}>
            <Row middle="xs" className="links-container">
              {lastVisitedLeagueData && !_.isEmpty(lastVisitedLeagueData) && (
                <Col xs={12}>
                  <LastVisitedLeagueComponent leagueName={ lastVisitedLeagueData.name }
                                              leagueProduct={ lastVisitedLeagueData.product }
                                              url={ lastVisitedLeagueData.url } />
                </Col>
              )}
              {registrationLeagueData && !_.isEmpty(registrationLeagueData) && (
                <Col xs={12}>
                  <RegistrationLeagueComponent leagueName={ registrationLeagueData.name }
                                               url={ registrationLeagueData.url } />
                </Col>
              )}
            </Row>
          </Col>
          <Col xs={12} md={9} lg={5} xl={6}>
            <LeagueNameFilter value={ leagueName } onChange={ changeFilter } loadingFilters={ loadingFilters } />
          </Col>
          <Col xs={12} md={3} lg={3} xl={2}
               className="view-types-and-toggle no-lite">
            <Row end="xs">
              <Col sm={7} smOffset={1} xs={8}>
                {userIsManager && (
                  <ViewTypeFilter viewType={ viewType }
                                  onChange={ changeFilter }
                                  disabled={ dataIsLoading } />
                )}
              </Col>
              <Col xs={4}>
                <AdvancedFiltersToggle open={ advancedFiltersOn }
                                       onChange={ changeFilter }
                                       disabled={ dataIsLoading } />
              </Col>
            </Row>
          </Col>
        </Row>
        <Collapse in={ advancedFiltersOn }>
          <div className="transition-wrapper">
            <Row>
              {showSeasons && (
                <Col xs={12} sm={6} md={6} lg={true} className="no-lite">
                  <SeasonFilter seasonsOptions={ seasonsOptions }
                                value={ selectedSeason }
                                onChange={ changeFilter }
                                isCustomized={ true } />
                </Col>
              )}
              {userIsManager && (
                <Fragment>
                  {(showCategoryFilter || dataIsLoading) && (
                    <Col xs={12} sm={6} md={6} lg={true} className="no-lite">
                      <CategoryFilter categoriesOptions={ categoriesOptions }
                                      value={ selectedCategory }
                                      onChange={ changeFilter }
                                      disabled={ dataIsLoading }
                                      isCustomized={ true } />
                    </Col>
                  )}
                  {showTours && (
                    <Col xs={12} sm={6} md={6} lg={true}>
                      <TourFilter toursOptions={ toursOptions }
                                  value={ selectedTour }
                                  onChange={ changeFilter }
                                  isCustomized={ true } />
                    </Col>
                  )}
                </Fragment>
              )}
              <Col xs={12} sm={6} md={6} lg={true} className="no-lite">
                <RegistrationFilter value={ selectedRegistration }
                                    onChange={ changeFilter }
                                    disabled={ dataIsLoading }
                                    showRegistrationOptions={ showRegistrationOptions }
                                    golfHubEnabled={ golfHubEnabled }
                                    isCustomized={ true } />
              </Col>
              <Col xs={12} sm={6} md={6} lg={3}>
                <SortingFilter sortingColumn={ sortingColumn }
                               sortingOrder={ sortingOrder }
                               onSortingColumnChange={ changeSortingColumn }
                               onSortingOrderChange={ changeSortingOrder }
                               includeSeasonsOption={ showSeasons }
                               includeToursOption={ showTours }
                               includeCategoryOption={ viewType === 'list' }
                               userIsCustomerManager={ userIsCustomerManager }
                               userIsTourManager={ userIsTourManager }
                               disabled={ dataIsLoading }
                               showRegistrationOptions={ showRegistrationOptions } />
              </Col>
            </Row>
          </div>
        </Collapse>
      </div>
    )
  }
}

CategoriesFiltersComponent.propTypes = {
  seasonsOptions: PropTypes.array.isRequired,
  showSeasons: PropTypes.bool.isRequired,
  categoriesOptions: PropTypes.array.isRequired,
  showCategoryFilter: PropTypes.bool.isRequired,
  toursOptions: PropTypes.array.isRequired,
  showTours: PropTypes.bool.isRequired,
  leagueName: PropTypes.string.isRequired,
  viewType: PropTypes.string.isRequired,
  advancedFiltersOn: PropTypes.bool.isRequired,
  sortingColumn: PropTypes.string.isRequired,
  sortingOrder: PropTypes.string.isRequired,
  selectedSeason: PropTypes.string.isRequired,
  selectedCategory: PropTypes.string.isRequired,
  selectedTour: PropTypes.string.isRequired,
  selectedRegistration: PropTypes.string.isRequired,
  lastVisitedLeagueData: PropTypes.shape({
    name: PropTypes.string,
    product: PropTypes.string,
    url: PropTypes.string,
  }),
  registrationLeagueData: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
  }),
  userIsCustomerManager: PropTypes.bool.isRequired,
  userIsTourManager: PropTypes.bool.isRequired,
  showRegistrationOptions: PropTypes.bool.isRequired,
  changeFilter: PropTypes.func.isRequired,
  changeSortingColumn: PropTypes.func.isRequired,
  changeSortingOrder: PropTypes.func.isRequired,
  dataIsLoading: PropTypes.bool.isRequired,
  loadingFilters: PropTypes.bool,
  golfHubEnabled: PropTypes.bool,
}

export default CategoriesFiltersComponent
